import React from 'react';
import {Link} from 'react-router';
import {connect} from 'react-redux';
let classNames = require('classnames');

class MenuItem extends React.Component {
	getChildRoutes(children) {
		let routes = [];
		if (children && children.length) {
			children.forEach(item => {
				if (item.props.path)
					routes.push(item.props.path);

				if (item.props.children) {
					routes = routes.concat(this.getChildRoutes(item.props.children));
				}
			});
		} else {
			if (children.props.path)
				routes.push(children.props.path);

			if (children.props.children) {
					routes = routes.concat(this.getChildRoutes(children.props.children));
				}
		}

		return routes;
	}

	render() {
		//  className={`menu-items menu-haschildren ${this.props.routerName=='tiepcongdan' ? 'is-active' : ''}`}
		let menuClass = [
			'menu-items'
		];
		if (this.props.children) {
			menuClass.push('menu-haschildren');
		}

		// if current route is same with this.props.path
		if (this.props.path == this.props.routePath) {
			menuClass.push('is-active');	
		}

		return (
			<li className={classNames(menuClass)}>
				<Link to={this.props.path} id={this.props.id} className="item-link">
					{
						this.props.icon ?
						<div className="wrap-img-mn"><img src={this.props.icon} alt="menuIcon"/></div>
						: ''
					}
					{this.props.name}
				</Link>
				{
					this.props.children
				}
			</li>
		)
	}
}

MenuItem.defaultProps = {
	id: ''
}

let mapStateToProps = (state) => {
	return {
		routePath: state.routing.locationBeforeTransitions.pathName
	}
}
export default connect(mapStateToProps)(MenuItem);


// WEBPACK FOOTER //
// ./src/components/menu/MenuItem.jsx